import { i18n } from "@lingui/core";
import { WIcon } from "@mobility-item-page/client";
import { ObjectPosition } from "../../types/objectPosition.ts";
import { useValidDealerItemContext } from "../context/DealerItemProviderContext.tsx";
import { VisibleActions } from "./Actions.tsx";

export const SalesPersonDetails = () => {
  const {
    itemData: { salesPersonContactInfo },
  } = useValidDealerItemContext();

  if (!salesPersonContactInfo) {
    return null;
  }

  const { name, title, imageURL } = salesPersonContactInfo;

  return (
    <div className="flex items-start gap-16 p-16 border-t">
      {imageURL ? (
        <img
          className="h-[58px] w-[58px] shrink-0 mt-2 rounded-full border-1"
          src={imageURL}
          alt={title ? title : i18n.t({ id: "dealer.salesPersonDetails.defaultAltText", message: "Sales person" })}
        />
      ) : (
        <div className="flex h-[58px] w-[58px] shrink-0 mt-2 s-bg-subtle rounded-full border-1 items-center justify-center">
          <WIcon name="CircleUser" size="large" className="s-text-disabled" />
        </div>
      )}
      <div>
        {name && <h3 className="text-body m-0">{name}</h3>}
        {title && <p className="text-detail mb-4">{title}</p>}
        <VisibleActions position={ObjectPosition.InfoCard} />
      </div>
    </div>
  );
};
